import { NFormTable } from "../../../Shared/NewForms/NFormTable";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFLookupFixedAsset } from "../../../Shared/NewForms/NFLookupFixedAsset";
import { NFLookupConstructionObject } from "../../../Shared/NewForms/NFLookupConstructionObject";

export const FixedAssetsTakeInAccountsDetailAccountConstruction = () => {
    const { t } = useTranslation();


    useEffect(() => {}, []);

    return (
        <>
            <NFormTable
                fieldArray={"fixedAssetsTakeInAccountConstructionObjectDto"}
            >
                <NFTextInput fieldName="lineNo" title={t("LineNo")} />
                <NFLookupFixedAsset
                    fieldName={"fixedAssetsTakeInAccountId"}
                    title={t("FixedAssetTakeInAccountID")}
                />
                <NFLookupConstructionObject
                    title={t("ConstructionObject")}
                    fieldName="constructionObjectId"
                />
            </NFormTable>
        </>
    );
};
